import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../PageHeader/PageHeader'
import AppButton from '../../../components/AppButton/AppButton';
import AppInput from '../../../components/AppInput/AppInput';
import { useDispatch, useSelector } from 'react-redux';
import TextArea from '../../../components/AppInput/TextArea';
import FileuploadComp from '../../../components/SingleFileUpload/FileuploadComp';
import { addSalonParent, updateSalonParent, searchSalonParent } from '../../../constant/Constant';
import { setApiErrorJson, setApiJson } from '../../../redux/Actions/ApiAction';
import { getSelectedUnit } from '../../../storage/Storage';
import { HitApi } from '../../../Api/ApiHit';
import toast from 'react-hot-toast';
import { getErrorMsg, hasError } from '../../../utils/utils';

function AddSalonParent() {
    const [isEditMode, setIsEditMode] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoadingOptions, setIsLoadingOptions] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const url = window.location.pathname;
    const urlId = url.split('/')[3];

    const ApiReducer = useSelector((state) => state.ApiReducer);

    useEffect(() => {
        const initialParentData = {
            name: "",
            parentDesc: "",
            img: ""
        };

        if (urlId) {
            setIsEditMode(true);
            loadParentData();
        } else {
            dispatch(setApiJson(initialParentData));
            dispatch(setApiErrorJson({}));
        }
    }, [dispatch, urlId]);

    const loadParentData = () => {
        setIsLoadingOptions(true);

        const selectedUnit = getSelectedUnit();

        var json = {
            page: 1,
            limit: 10,
            search: {
                _id: urlId,
                unitIds: selectedUnit?._id
            }
        };

        HitApi(json, searchSalonParent).then((res) => {
            if (res?.statusCode === 200) {
                const parentData = res?.data?.docs?.[0];
                if (parentData) {
                    dispatch(setApiJson(parentData));
                } else {
                    toast.error('No salon parent data found');
                }
            } else {
                toast.error('Failed to load salon parent data');
            }
        }).catch((error) => {
            toast.error('Error loading salon parent data. Please try again.');
        }).finally(() => {
            setIsLoadingOptions(false);
        });
    };

    const validateForm = (data) => {
        const errors = {};
        if (!data.name || data.name.trim() === '') {
            errors.name = 'Name is required';
        }
        return errors;
    };

    const handleSubmit = () => {
        setIsSubmitting(true);

        const errors = validateForm(ApiReducer?.apiJson);
        dispatch(setApiErrorJson(errors));

        if (Object.keys(errors).length === 0) {
            const selectedUnit = getSelectedUnit();

            const parentData = {
                ...ApiReducer.apiJson,
                unitIds: selectedUnit?._id
            };

            if (isEditMode) {
                parentData._id = urlId;
                HitApi(parentData, updateSalonParent).then((res) => {
                    if (res?.statusCode === 200) {
                        toast.success('Salon group updated successfully!');
                        setTimeout(() => {
                            navigate('/salonServices');
                        }, 1000);
                    } else {
                        toast.error('Failed to update salon group. Please try again.');
                    }
                }).catch((error) => {
                    toast.error('Error updating salon group. Please try again.');
                }).finally(() => {
                    setIsSubmitting(false);
                });
            } else {
                HitApi(parentData, addSalonParent).then((res) => {
                    if (res?.statusCode === 201 || res?.success) {
                        toast.success('Salon group added successfully!');
                        setTimeout(() => {
                            navigate('/salonServices');
                        }, 1000);
                    } else {
                        toast.error('Failed to add salon group. Please try again.');
                    }
                }).catch((error) => {
                    toast.error('Error adding salon group. Please try again.');
                }).finally(() => {
                    setIsSubmitting(false);
                });
            }
        } else {
            setIsSubmitting(false);
        }
    }

    return (
        <div className='p-5'>
            <PageHeader
                title={isEditMode ? 'Update Salon Group' : 'Add New Salon Group'}
                description={isEditMode ? 'Update salon group information' : 'Create a new salon group'}
            />

            <div className="bg-white p-8 border rounded-xl mb-6">
                <div className="text-lg font-medium mb-5 flex justify-between items-center">
                    <span>Salon Group Information</span>
                </div>

                <div className="grid grid-cols-1 gap-4 mb-6">
                    <AppInput
                        title="Group Name"
                        placeholder="Enter group name"
                        name="name"
                        error={hasError('name', ApiReducer)}
                        errormsg={getErrorMsg('name', ApiReducer)}
                        important={true}
                        str
                    />
                    <TextArea
                        title="Description"
                        name="parentDesc"
                        placeholder="Describe the salon group..."
                        rows={3}
                    />
                    <div className='mb-5'>
                        <FileuploadComp title="Image URL" name="img" allowed={["img"]} />
                    </div>
                </div>
                <div className='flex justify-end mt-5'>
                    <AppButton
                        buttontext={isSubmitting ? "Processing..." : (isEditMode ? "Update Group" : "Add Group")}
                        onClick={handleSubmit}
                        disabled={isSubmitting || isLoadingOptions}
                        isLoading={isSubmitting}
                    />
                </div>
            </div>
        </div>
    )
}

export default AddSalonParent
